module.exports = __webpack_public_path__ + "images/ico-contents.svg?fc48a32be02148ecf1572418a6144bc8";